import { useEffect, useState } from "react";
import ModalBackground from "../../../components/common/ModalBackground";
import localize from "../../../common/localize";
import { TextField } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import useGlobalContext from "../../../hooks/useGlobalContext";
import Combobox from "../../../components/common/Combobox";
import { getClearZoneModel } from "../../../common/EntitiesManagement";

export default function AddOrEditZone({
  zoneModel,
  showModalOnScreen,
  setShowModalOnScreen,
  callBack,
}) {
  const {
    locations,
    cities,
    config,
    LOCATION_API,
    setCityFilterCode,
    setCity,
    createEntity,
    updateEntity,
  } = useGlobalContext();

  const [model, setModel] = useState(zoneModel);
  const [states, setStates] = useState(null);
  const [citiesData, setCities] = useState(null);

  useEffect(() => {
    console.log("MODEL", model);
  }, [model]);

  useEffect(() => {
    if (locations.Ok && locations.Data.length > 0) {
      setStates(locations.Data);
    }
  }, [locations]);

  useEffect(() => {
    if (cities?.Ok && cities.Data.length > 0) {
      setCities(cities.Data);
    }
  }, [cities]);

  useEffect(() => {
    if (model?.GrandParentCode) {
      setCity(model.GrandParentCode);
    }
  }, [model?.GrandParentCode]);

  const handleStateChange = (currentState) => {
    if (!currentState) {
      setModel({
        ...model,
        GrandParentCode: null,
        State: null,
        ParentCode: null,
        City: null,
      });
      return;
    }

    setModel({
      ...model,
      GrandParentCode: currentState.Code,
      State: currentState,
      ParentCode: null,
      City: null,
    });
  };

  const handleCityChange = (currentCity) => {
    if (!currentCity) {
      setModel({
        ...model,
        ParentCode: null,
        City: null,
      });
      return;
    }

    setModel({
      ...model,
      ParentCode: currentCity.Code,
      City: currentCity,
    });
    setCityFilterCode(currentCity.Code);
  };

  const handleChange = (field) => {
    setModel({
      ...model,
      [field.target.name]: field.target.value,
    });
  };

  const disableChanges = () =>
    !model?.Code ||
    !model?.Name ||
    !model?.GrandParentCode ||
    !model?.ParentCode;

  const getComponents = () => {
    return (
      <div className="flex flex-col gap-3 w-full mt-3">
        <TextField
          sx={{ width: "100%" }}
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            ...getInputProps(),
            style: { textTransform: "uppercase" },
            maxLength: 10,
          }}
          size="small"
          fullWidth
          id="outlined-basic"
          name="Code"
          label={localize.code}
          variant="outlined"
          onChange={handleChange}
          value={model.Code}
        />

        <TextField
          sx={{ width: "100%" }}
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          fullWidth
          id="outlined-basic"
          name="Name"
          label={localize.name}
          variant="outlined"
          onChange={handleChange}
          value={model.Name}
        />

        <div className="flex justify-between my-3">
          <Combobox
            isRequired
            id="State"
            handleValueChange={handleStateChange}
            fieldValue={model?.State}
            fieldOptions={states ?? []}
            fieldLabel={localize.department}
          />

          {/* Cities */}
          <div className="mx-2" />
          <Combobox
            disabled={!model.State || citiesData?.length === 0}
            isRequired
            id="City"
            handleValueChange={handleCityChange}
            fieldValue={model?.City}
            fieldOptions={model?.State ? citiesData ?? [] : []}
            fieldLabel={localize.city}
          />
        </div>
      </div>
    );
  };

  const handleCreateOrUpdateRequest = async () => {
    const data = {
      Name: model.Name,
      Code: model.Code,
      GrandParentCode: model.GrandParentCode,
      ParentCode: model.ParentCode,
      Points: model.Points,
    };

    if (model?.Id > 0) {
      const updateResult = await updateEntity(
        `${`${LOCATION_API}/${model.Id}`}`,
        data,
        config,
      );

      callBack && callBack(updateResult, false);
      return;
    }

    const creationResult = await createEntity(
      `${`${LOCATION_API}`}`,
      data,
      config,
    );

    callBack && callBack(creationResult, false);
  };

  return (
    <ModalBackground
      isDrawerMode
      hasRequiredValues
      showModal={showModalOnScreen}
      setShowModal={setShowModalOnScreen}
      title={model?.Id > 0 ? localize.edit_zone : localize.new_zone}
      onClickToSubmit={() => {
        handleCreateOrUpdateRequest();
        setModel(getClearZoneModel());
        setShowModalOnScreen(false);
      }}
      onClickToCancel={() => {
        setModel(getClearZoneModel());
        setShowModalOnScreen(false);
      }}
      Component={getComponents()}
      validators={disableChanges()}
    />
  );
}
